export default __webpack_public_path__ + "static/media/toggle-support-w.4e30114a.svg";